//@flow
import React, { Component } from 'react';
import { CustomModelListTd, CustomToggleDetails } from '../../StatisticsStyles';
import DefaultModelRowTr from '../../../../modules/CrudTable/components/DefaultModelRowTr';

type Props = {
  options: Array<any>,
  first?: boolean,
  noBorder?: boolean,
  toggleState: string,
  setToggleState: () => void
};

export default class TableRowDesktopPartial extends Component<Props> {
  static defaultProps = { noBorder: true };
  render() {
    return (
      <DefaultModelRowTr>
        {this.props.options.map((item, i) => (
          <CustomModelListTd
            key={i}
            right={item.right}
            noBorder={this.props.noBorder}
            first={this.props.first}
            bold={item.bold}
            extraBold={item.value === 'TOTAL'}
            customPadding={item.customPadding}
          >
            {item.value === 'toggle' ? (
              <CustomToggleDetails
                iconName={
                  this.props.toggleState
                    ? 'minusCircleThick'
                    : 'plusCircleThick'
                }
                text="Details"
                activeText="Hide"
                inActiveText="View"
                setToggleState={this.props.setToggleState}
                toggleState={this.props.toggleState}
              />
            ) : (
              item.value
            )}
          </CustomModelListTd>
        ))}
      </DefaultModelRowTr>
    );
  }
}
